import { Component, ViewChild, ElementRef, AfterViewInit, Output, EventEmitter, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import SignaturePad from 'signature_pad';
import { MatIconModule } from "@angular/material/icon";

@Component({
  selector: 'app-signature',
  standalone: true,
  imports: [
    CommonModule, 
    MatButtonModule, 
    MatIconModule
  ],
  templateUrl: './signature.html',
  styleUrl: './signature.scss',
})
export class SignatureComponent implements AfterViewInit {
  @ViewChild('canvas', { static: true }) canvas!: ElementRef;
  @Output() signatureConfirmed = new EventEmitter<string>(); // Emit to parent

  private _initialValue: string | null = null;

  @Input() set value(val: string | null) {
    if (this.signaturePad && val) {
      if (this.signaturePad.isEmpty()) {
        this.signaturePad.fromDataURL(val);
        this.lock();
      }
    } else {
      this._initialValue = val;
    }
  }
  
  signaturePad!: SignaturePad;
  isLocked = false; // State to track locking

  ngAfterViewInit() {
    this.signaturePad = new SignaturePad(this.canvas.nativeElement);

    if (this._initialValue) {
      this.signaturePad.fromDataURL(this._initialValue);
      this.lock();
    }
  }

  clear() {
    this.signaturePad.clear();
    this.unlock(); // Always unlock when clearing
  }

  save() {
    if (this.signaturePad.isEmpty()) {
      alert("Please provide a signature first.");
      return;
    }
    
    const dataURL = this.signaturePad.toDataURL();
    this.lock(); // Disable the canvas
    this.signatureConfirmed.emit(dataURL); // Send to parent
  }

  lock() {
    this.isLocked = true;
    this.signaturePad.off(); // Disables drawing events
  }

  unlock() {
    this.isLocked = false;
    this.signaturePad.on(); // Re-enables drawing events
  }
}
// import { CommonModule } from '@angular/common';
// import { Component, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
// import { MatButtonModule } from '@angular/material/button';
// import SignaturePad from 'signature_pad';
// import { SignatureDto } from '../../models/signature.model';
// import { HttpClient } from '@angular/common/http';

// @Component({
//   selector: 'app-signature',
//   imports: [
//     CommonModule,
//     MatButtonModule
//   ],
//   templateUrl: './signature.html',
//   styleUrl: './signature.scss',
// })
// export class SignatureComponent implements AfterViewInit {
//   @ViewChild('canvas', { static: true }) canvas!: ElementRef;
//   signaturePad!: SignaturePad;

//   constructor(private http: HttpClient) {}
//   ngAfterViewInit() {
//     this.signaturePad = new SignaturePad(this.canvas.nativeElement);
//   }

//   clear() {
//     this.signaturePad.clear();
//   }

//   save() {
//     if (this.signaturePad.isEmpty()) {
//       alert("Please provide a signature first.");
//     } else {
//       const dataURL = this.signaturePad.toDataURL(); // This is your Base64 string
//       console.log(dataURL);
//       // Now call your Spring Boot service: 
//       // this.bookingService.uploadSignature(dataURL).subscribe(...);
      
//       const signatureData: SignatureDto = {
//         base64Signature: this.signaturePad.toDataURL(),
//         userId: '123',
//         signerName: 'Testing'
//       };

//       // this.http.post('http://localhost:8080/document/sign', signatureData).subscribe((response: any) => {
//       //   console.log('Document signed and saved!', response);
//       // });

//     }
//   }
// }
